import { Grid, GridColumn } from '@fieldnation/platform-components';
import React from 'react';
import { useRecoilCallback, useRecoilValue } from 'recoil';
import { sectionContentsState } from '../../States/AtomFamilies';
import { onCloseSection, onSaveSection } from '../../States/Callbacks';
import isSectionOnSaveDisabled from '../../States/SelectorFamilies';
import ActionBar from '../ActionBar';
import FileUpload from '../FileUpload';
import ImageContent from '../ImageContent';
import InputTextContent from '../InputTextContent';
import { ContentType, CustomEditComponent } from '../Section/types.d';
import css from './styles.scss';
import SmartAddress from '../SmartAddress';
import { IProps } from './types.d';

const EditSectionContent: React.FC<IProps> = ({
  sectionKey,
  contentConfigs,
  customEditComponent,
  onEditConfig,
  sectionDisplayName,
  cardKey,
  windowRef,
}: IProps): JSX.Element => {
  const contents = useRecoilValue(sectionContentsState(sectionKey));
  const contentStyle = contents.length > 1 ? 'multiple' : 'single';
  const onClose = useRecoilCallback(onCloseSection);
  const isOnSaveDisabled = useRecoilValue(isSectionOnSaveDisabled(sectionKey));
  const onSave = useRecoilCallback(onSaveSection);
  return (
    <div>
      <Grid>
        <GridColumn
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
        >
          {customEditComponent === CustomEditComponent.SMART_ADDRESS && (
            <SmartAddress
              sectionKey={sectionKey}
              onEditConfig={onEditConfig}
              sectionDisplayName={sectionDisplayName}
            />
          )}
          {customEditComponent === CustomEditComponent.NONE && contentConfigs.map((config) => (
            <div key={config.key} className={css[`section--edit--${contentStyle}`]}>
              {config.contentType === ContentType.IMAGE ? (
                <div>
                  <ImageContent
                    href={
                      contents.find((content) => content?.key === config.key)
                        ?.value || ''
                    }
                    version={
                      contents.find((content) => content?.key === config.key)
                        ?.version || 0
                    }
                    alt={config.displayName}
                  />
                  <FileUpload
                    sectionKey={sectionKey}
                    acceptFiles={config.acceptFiles || []}
                    multiple={config.useMultipleFiles || false}
                  />
                </div>
              ) : (
                <InputTextContent
                  sectionKey={sectionKey}
                  config={config}
                  shouldFocus={contentConfigs.length === 1}
                />
              )}
            </div>
          ))}
          {customEditComponent === CustomEditComponent.NONE && (
          <ActionBar
            onSave={() => onSave(
              sectionKey,
              onEditConfig,
              false,
              sectionDisplayName,
              cardKey,
              windowRef,
            )}
            onClose={() => onClose(sectionKey)}
            isOnSaveDisabled={isOnSaveDisabled}
          />
          )}
        </GridColumn>
      </Grid>
    </div>
  );
};

export default EditSectionContent;
